import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-earnings',
  templateUrl: './select-earnings.component.html',
  styleUrls: ['./select-earnings.component.scss']
})
export class SelectEarningsComponent implements  OnDestroy {

  public items: any[] = [
    { value: 1, name: 'Venta Litros' },
    { value: 2, name: 'Gan Bruta Total $' },
    { value: 3, name: 'Gan Bruta x Litro' }
  ];

  public variableEarning: any = [];
  public ngxDisabled = false;
  variableEarning$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.variableEarning$ = this.sharedService.sharedVariableEarning.subscribe(variableEarning => {
      this.variableEarning = variableEarning;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableEarning$.unsubscribe();
  }

  changeVariable(event: any) {
    this.variableEarning = event;
    this.sharedService.nextVariableEarning = this.variableEarning;
  }
}
